import { cn } from "@/utils/cn";

interface NavLinksProps {
  className?: string;
  children: React.ReactNode;
}

/** Flex container for NavLink items — hidden on mobile, visible on desktop. */
export const NavLinks: React.FC<NavLinksProps> = ({ className, children }) => {
  return (
    <div
      data-navlinks
      className={cn(
        "flex flex-col flex-wrap items-center justify-evenly gap-3 font-semibold md:flex-row md:gap-10 lg:gap-14",
        className,
      )}
    >
      {children}
    </div>
  );
};
